export default __webpack_public_path__ + "static/media/dv_1.e9e00e8a.svg";